






















import { Component, Vue, Prop } from "vue-property-decorator";
import { IShopListItem } from "@/models/shop";

@Component
export default class MigrationProductDetailModal extends Vue {
  // Props
  @Prop({ required: true })
  public item!: IShopListItem;
  // Computed
  public get imagePath() {
    return this.$_.get(this.item, "image", false)
      ? `${this.$_.get(this.item, "image.full_url")}?size=400x400`
      : null;
  }
}
